import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Users, Shield, Database, Activity, MapPin, AlertTriangle } from 'lucide-react';
import { KPICard } from '../components/KPICard';
import { StatusBadge } from '../components/StatusBadge';
import { Button } from '../components/Button';
import { useNavigate } from 'react-router-dom';
import { NASIONAL, TOP_PRIORITAS } from '../data/binda';
import { useStore } from '../data/store';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/Table';
import { FilterBar, FilterField } from '../components/FilterBar';
import { Filter } from 'lucide-react';
import { SyncButton } from '../components/SyncButton';
export default function AdministratorNasionalDashboard() {
  const navigate = useNavigate();
  const usersList = useStore(s => s.users);
  const auditLogList = useStore(s => s.auditLog);
  const [showFilters, setShowFilters] = useState(false);
  const [filterValues, setFilterValues] = useState<Record<string, any>>({});
  const handleFilterChange = (key: string, value: any) => {
    setFilterValues(prev => ({
      ...prev,
      [key]: value
    }));
  };
  const handleResetFilters = () => {
    setFilterValues({});
  };
  const filterFields: FilterField[] = [{
    key: 'date',
    label: 'Periode Waktu',
    type: 'datePreset'
  }, {
    key: 'region',
    label: 'Wilayah',
    type: 'select',
    options: [{
      label: 'Nasional',
      value: 'Nasional'
    }, {
      label: 'DKI Jakarta',
      value: 'DKI Jakarta'
    }, {
      label: 'Jawa Barat',
      value: 'Jawa Barat'
    }]
  }];
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-591">
      <div className="flex justify-between items-end border-b border-border/50 pb-4" data-id="element-592">
        <div data-id="element-593">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-foreground uppercase" data-id="element-594">
            KONSOL ADMINISTRATOR NASIONAL
          </h1>
          <p className="text-muted-foreground font-mono text-xs mt-1 uppercase tracking-widest" data-id="element-595">
            Manajemen Sistem & Pengguna Terpusat
          </p>
        </div>
        <div className="flex gap-3 items-center" data-id="element-596">
          <Button variant={showFilters ? 'default' : 'outline'} size="sm" onClick={() => setShowFilters(!showFilters)} className={`h-8 border-border/50 font-mono text-xs ${showFilters ? 'bg-primary text-primary-foreground' : 'bg-background/50'}`} data-id="element-597">
            <Filter className="w-4 h-4 mr-2" data-id="element-598" />
            Filter
          </Button>
          <SyncButton data-id="element-599" />
        </div>
      </div>

      {showFilters && <FilterBar fields={filterFields} values={filterValues} onChange={handleFilterChange} onApply={() => {}} onReset={handleResetFilters} data-id="element-600" />}

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4" data-id="element-601">
        <KPICard title="Total Pengguna" value={usersList.length} icon={Users} colorVar="var(--primary)" onClick={() => navigate('/users')} data-id="element-602" />
        <KPICard title="Wilayah Aktif" value={NASIONAL.totalBinda} icon={MapPin} colorVar="var(--status-info)" onClick={() => navigate('/regional')} data-id="element-603" />
        <KPICard title="Status Sinkronisasi" value="100%" icon={Database} colorVar="var(--status-active)" progress={{
        value: 100,
        label: 'Data Master',
        target: 'Sinkron'
      }} data-id="element-604" />
        <KPICard title="Log Audit (24j)" value={auditLogList.length} icon={Activity} colorVar="var(--muted-foreground)" onClick={() => navigate('/audit-log')} data-id="element-605" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-606">
        {/* Recent Audit Logs */}
        <Card className="glass-panel border-border/50 flex flex-col" data-id="element-607">
          <CardHeader className="p-4 border-b border-border/50 bg-card/50 flex flex-row items-center justify-between" data-id="element-608">
            <CardTitle className="text-sm font-mono uppercase tracking-widest flex items-center gap-2" data-id="element-609">
              <Shield className="w-4 h-4 text-primary" data-id="element-610" /> Aktivitas Sistem
              Terbaru
            </CardTitle>
            <Button variant="ghost" size="sm" className="text-[10px] font-mono" onClick={() => navigate('/audit-log')} data-id="element-611">
              Lihat Semua
            </Button>
          </CardHeader>
          <CardContent className="p-0 flex-1 overflow-auto" data-id="element-612">
            <Table data-id="element-613">
              <TableHeader className="bg-black/20" data-id="element-614">
                <TableRow className="border-border/30 hover:bg-transparent" data-id="element-615">
                  <TableHead className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground" data-id="element-616">
                    Waktu
                  </TableHead>
                  <TableHead className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground" data-id="element-617">
                    Pengguna
                  </TableHead>
                  <TableHead className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground" data-id="element-618">
                    Aksi
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-619">
                {auditLogList.slice(0, 5).map(log => <TableRow key={log.id} className="border-border/20 hover:bg-white/5 transition-colors" data-id="element-620">
                    <TableCell className="font-mono text-[10px] text-muted-foreground" data-id="element-621">
                      {log.timestamp.split(' ')[1]}
                    </TableCell>
                    <TableCell className="font-medium text-xs" data-id="element-622">
                      {log.actor}
                    </TableCell>
                    <TableCell className="text-xs" data-id="element-623">{log.action}</TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </CardContent>
        </Card>

        {/* Priority Regions Overview */}
        <Card className="glass-panel border-border/50 flex flex-col" data-id="element-624">
          <CardHeader className="p-4 border-b border-border/50 bg-card/50 flex flex-row items-center justify-between" data-id="element-625">
            <CardTitle className="text-sm font-mono uppercase tracking-widest flex items-center gap-2" data-id="element-626">
              <AlertTriangle className="w-4 h-4 text-[var(--status-standby)]" data-id="element-627" />{' '}
              Wilayah Perhatian Khusus
            </CardTitle>
            <Button variant="ghost" size="sm" className="text-[10px] font-mono" onClick={() => navigate('/regional')} data-id="element-628">
              Peta Nasional
            </Button>
          </CardHeader>
          <CardContent className="p-0 flex-1 overflow-auto" data-id="element-629">
            <div className="divide-y divide-border/50" data-id="element-630">
              {TOP_PRIORITAS.slice(0, 5).map(region => <div key={region.kode} className="p-4 hover:bg-secondary/30 transition-colors cursor-pointer flex justify-between items-center" onClick={() => navigate(`/regional/${region.kode}`)} data-id="element-631">
                  <div data-id="element-632">
                    <div className="font-heading font-semibold text-sm mb-1" data-id="element-633">
                      {region.provinsi}
                    </div>
                    <div className="text-[10px] font-mono text-muted-foreground" data-id="element-634">
                      {region.laporanPrioritas} Laporan Prioritas
                    </div>
                  </div>
                  <StatusBadge status={region.status} data-id="element-635" />
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}